export enum ModulesEnum {
  LEGAL_ASSISTANT = 'LEGAL_ASSISTANT',
  DOC_REVIEWING = 'DOC_REVIEWING',
  LEGAL_MEMO = 'LEGAL_MEMO',
  DOC_DRAFTING = 'DOC_DRAFTING'
}

export enum SubModulesEnum {
  LEGAL_ASSISTANT_KARNOV_INDEX = 'LEGAL_ASSISTANT_KARNOV_INDEX',
  LEGAL_ASSISTANT_USER_INDEX = 'LEGAL_ASSISTANT_USER_INDEX',
  DOC_REVIEWING_CHAT = 'DOC_REVIEWING_CHAT',
  DOC_REVIEWING_KEYPOINTS = 'DOC_REVIEWING_KEYPOINTS'
}
